import { Pipe, PipeTransform } from '@angular/core';
import { CreditEnrollmentEnum, TypeOfClassPracticalEnum, TypeOfCreditReleaseEnum } from '@core/enums/type-of-practical-scheduling.enum';

@Pipe({ name: 'typeOfPracticalSchedulingPipe' })
export class TypeOfPracticalSchedulingPipe implements PipeTransform {

  items = { ...TypeOfCreditReleaseEnum, ...TypeOfClassPracticalEnum, ...CreditEnrollmentEnum }

  transform(value: string): string {
    return this.items[value];
  }
}
